import { Stack, Typography } from '@mui/material';

export const FormError = ({
  message,
  testId,
}: {
  message: string;
  testId?: string;
}) => (
  <Stack
    direction='row'
    sx={{ gap: '4px', alignItems: 'center', justifyContent: 'center' }}
  >
    <i className='material-symbols-close-rounded w-[20px] h-[20px] text-(--mui-palette-error-main)' />
    <Typography
      variant='subtitle1'
      data-testid={testId}
      sx={{ color: 'error.main' }}
    >
      {message}
    </Typography>
  </Stack>
);
